import { onConsentGiven } from "@ocm/services/services.consent";
import { setEpoqCartData } from "@ocm/services/services.epoq";

function init() {
	onConsentGiven("epoq", setEpoqCartData);
}

export { init };
